export default __webpack_public_path__ + "static/media/cancelled.bd1843ac.svg";